import React, { Component } from "react";
import PopupDialog from "../components/popup/Popup";

const PopupContext = React.createContext({});

export class PopupProvider extends Component{
    state = {
        isPopupVisible: false,
        popupContent: undefined
    }

    setIsPopupVisible = (isVisible: boolean) => {
        this.setState({isPopupVisible: isVisible});
    }

    setPopupContent = (content: HTMLElement | undefined) => {
        this.setState({popupContent: content});
    }

    render() {
        const { isPopupVisible } = this.state;
        const { setIsPopupVisible, setPopupContent } = this;
        return (
            <PopupContext.Provider value={{
                isPopupVisible,
                setIsPopupVisible,
                setPopupContent
            }}>
                {this.props.children}
                <PopupDialog
                    isVisible={this.state.isPopupVisible}
                    content={this.state.popupContent}
                    onClose={() => {setIsPopupVisible(false); setPopupContent(undefined);}}
                    />
            </PopupContext.Provider>
        )
    }
}

export default PopupContext;
